import { memo } from 'react';
import { useTranslation } from '@betty/i18n';
import { Box, Text, Icon } from '@betty/moonlight';
import { AmountLimitProps } from './AmountLimit.types';
import { formatAmount } from '@betty/toolkit/utils';

function AmountLimit({ accumulatedAmount, amount, period }: AmountLimitProps) {
  const { t } = useTranslation('wallet');

  return (
    <Box
      variant="outline-gradient"
      alignItems="center"
      flexDirection="row"
      borderRadius="radius-full"
      padding="space-200"
      gap="space-100"
    >
      <Icon
        name="info"
        gradient="accentBackground"
        width="space-400"
        height="space-400"
      />
      <Text variant="body-s" gradient="darkSurfaceAccent">
        {t('depositActiveLimit', {
          accumulatedAmount: formatAmount(accumulatedAmount),
          amount: formatAmount(amount),
          period: t(`deposit${period}Period`),
        })}
      </Text>
    </Box>
  );
}

export default memo(AmountLimit);
